import React from 'react';
import { MobileOnly } from 'src/ui/block';
import {
  AdFormat,
  AdPlacement,
  IAdContainerWithVisibilityProps,
} from 'src/components/ads/types';
import * as S from '../styles';

const advertSpacing = { top: '10px', bottom: '10px' };

const TOP_AD_ADS_INDEXES = [
  4,
  10,
  16,
  // Ad every 10th price row
  ...Array(16)
    .fill(10)
    .map((v, i) => v + v * i + 16),
];

const NO_TOP_AD_ADS_INDEXES = [
  1,
  5,
  9,
  15,
  // Ad every 6th price row
  ...Array(15)
    .fill(6)
    .map((v, i) => v + v * i + 15),
];

const getMobileAd = (index: number) => {
  const placementNumber = Math.min(3, index + 1);

  const triggerPointProp = placementNumber > 1 ? { triggerPoint: 100 } : {};

  return (
    <S.AdvertTableRowElement key={`mobile-ad-container-${index}`}>
      <MobileOnly>
        <S.AdContainer
          placement={`dubbelpanorama${placementNumber}` as AdPlacement}
          format={`panorama_${placementNumber}` as AdFormat}
          min={0}
          max={860}
          spacing={advertSpacing}
          async={index > 1}
          {...triggerPointProp}
        />
      </MobileOnly>
    </S.AdvertTableRowElement>
  );
};

const desktopAds: IAdContainerWithVisibilityProps[] = [
  { placement: 'panorama_extra', format: 'panorama_1_wde' },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
  {
    placement: 'panorama_extra_2',
    format: 'panorama_2_wde',
    triggerPoint: 100,
  },
];

const getDesktopAd = (index: number) => {
  const adProps = desktopAds[Math.min(desktopAds.length - 1, index)];
  return (
    <S.AdvertTableRowElement
      withPosition
      key={`desktop-ad-container-${index}`}
      className="pj-ui-pricelist--advert"
    >
      <S.AdContainer
        min={860}
        max={10000}
        scalable
        scaleBase=".pj-ui-pricelist--advert"
        spacing={advertSpacing}
        async={index > 1}
        {...adProps}
      />
    </S.AdvertTableRowElement>
  );
};

export const insertTableAds = (
  tableRows: JSX.Element[],
  isExperiment: boolean
) => {
  const mobileIndexes = isExperiment
    ? TOP_AD_ADS_INDEXES
    : NO_TOP_AD_ADS_INDEXES;
  // Only max 3 ads in desktop viewport
  const desktopIndexes = TOP_AD_ADS_INDEXES.slice(0, 3);
  const adjustedMobileAdsIndexes = mobileIndexes.filter(
    index => index <= tableRows.length
  );
  const adjustedDesktopAdsIndexes = desktopIndexes.filter(
    index => index <= tableRows.length
  );

  const tableRowWithAds: JSX.Element[] = [];

  tableRows.forEach((row, index) => {
    tableRowWithAds.push(row);

    if (adjustedMobileAdsIndexes.find(i => i === index + 1))
      tableRowWithAds.push(getMobileAd(index + 1));

    if (adjustedDesktopAdsIndexes.find(i => i === index + 1))
      tableRowWithAds.push(getDesktopAd(index + 1));
  });

  // special case for short list
  if (!adjustedMobileAdsIndexes.length) tableRowWithAds.push(getMobileAd(0));
  if (!adjustedDesktopAdsIndexes.length) tableRowWithAds.push(getDesktopAd(0));

  return tableRowWithAds;
};
